<h1 data-test="kc0JpEvl" mat-dialog-title *ngIf="data.title">
  {{ data.title }}
</h1>
<div data-test="Klg0be1K" mat-dialog-content>
  <p data-test="paGaRFZ0">{{ data.description }}</p>
</div>
<div data-test="oFSAM551" mat-dialog-actions>
  <button
    data-test="5xBYncN8"
    *ngFor="let action of data.actions"
    class="button button_secondary button_sm"
    mat-button
    [disabled]="action.disabled"
    (click)="proceed(action)"
  >
    {{ action.label }}
  </button>
</div>
